import { useDispatch, useSelector } from "react-redux";
import type { TypedUseSelectorHook } from "react-redux";
import type { RootState, AppDispatch } from "./store";

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

// Тъмна ли е темата — за компоненти, които подават РЕАЛНИ hex стойности на
// antd ConfigProvider token-и (token математиката на antd не разбира var()).
export const useIsDarkTheme = () =>
  useAppSelector((state) => state.theme.mode === "dark");
